import { call } from 'redux-saga/effects';
import { updateAction } from 'store/glue/operation/updateAction';
import { sagaWrapper } from 'store/helpers';
import { ActionType } from 'typesafe-actions';

import * as improvementsActions from './actions';

// Persists the edited action via the updateAction operation, which calls
// the API and updates the action domain on success.
export function* startUpdateActionSaga(
  _action: ActionType<typeof improvementsActions.startUpdateAction>,
) {
  function* saga() {
    const { action } = _action.payload;

    yield call(updateAction, { action });
  }

  yield call(sagaWrapper, { saga, type: _action.type });
}
